import type { ReactNode } from 'react';

export const symbol_moved_location: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M785-589q-101-17-188.5 13T435-474q45-103 141.5-159.5T786-690l-73-73q-9-9-9-21t9-21q9-9 21-9t21 9l144 144q9 9 9 21t-9 21L755-475q-9 9-21 9t-21-9q-9-9-9-21t9-21l72-72Zm-625 37q0-143 93-235.5T480-880q35 0 70 7.5t67 22.5q11 5 15.5 16.5T632-811q-5 11-16.5 15.5T593-796q-26-12-55-18t-58-6q-109 0-184.5 75T220-552q0 83 66 179.5T480-159q53-48 98-103t87-116q7-11 18.5-14t22.5 3q11 6 14 18t-4 23q-43 64-90 120T524-120q-9 9-20.5 13.5T480-102q-12 0-23.5-4.5T435-120Q301-241 230.5-347.5T160-552Z"
		/>
	</svg>
);
